module.exports = {"bewizr-agenda":{"empty":{"title":"Brak aktywności","detail":"Nie masz zaplanowanych aktywności."}}}